import ukisLogo from '@/assets/ukis_logo.png';

interface Props {
  className?: string;
}

export default function UkisBrand({ className = '' }: Props) {
  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`}>
      <span className="block h-[18px] w-[18px] shrink-0 overflow-hidden rounded-full">
        <img
          src={ukisLogo}
          alt=""
          aria-hidden="true"
          className="h-full w-auto max-w-none"
        />
      </span>
      <span className="font-ukis font-bold tracking-tight">UkisAI</span>
    </span>
  );
}
